import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/actions';
import EngineAllLogsView from './EngineAllLogsView';
import * as Constants from '../../../../HelperMethods/constants';
import EngineSingleLogView from './EngineSingleLogView';
import Joyn2Loader from '../../../common/Joyn2Loader';

class EngineLogView extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.props.engineLogViewActions.loadRunEngineHistoryForFieldId(this.props.fieldId);
  }

  componentDidUpdate(prevProps) {
    const { fieldId: prevFieldId } = prevProps;
    const { fieldId } = this.props;
    if (prevFieldId !== fieldId) {
      this.props.engineLogViewActions.loadRunEngineHistoryForFieldId(this.props.fieldId);
    }
  }

  componentWillUnmount() {
    this.goToAllLogsView();
  }

  loadRouteEngineData = (data) => {
    this.props.engineLogViewActions.loadRouteEngineData(data);
  };

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  goToAllLogsView = () => {
    this.props.engineLogViewActions.loadAllLogsView();
  };

  render() {
    const { rowData, currentView, isPageLoading, selectedLog, users, areas } = this.props;
    return (
      <>
        {isPageLoading && <Joyn2Loader />}
        {currentView === Constants.ENGINE_LOGS_VIEW.ENGINE_ALL_LOGS_VIEW && (
          <EngineAllLogsView
            goBack={this.goBack}
            loadRouteEngineData={this.loadRouteEngineData}
            rowData={rowData}
            users={users}
            areas={areas}
          />
        )}
        {currentView === Constants.ENGINE_LOGS_VIEW.ENGINE_SINGLE_LOG_VIEW && (
          <EngineSingleLogView goBack={this.goToAllLogsView} logData={selectedLog} />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowData: state.engineLogViewReducer.rowData,
    users: state.engineLogViewReducer.users,
    currentView: state.engineLogViewReducer.currentView,
    selectedLog: state.engineLogViewReducer.selectedLog,
    isPageLoading: state.engineLogViewReducer.isPageLoading,
    areas: state.appReducer.allAreas,
    fieldId: state.appReducer.selectedField.id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    engineLogViewActions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EngineLogView);
